import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=642f6e8d&scoped=true&"
import script from "./ContractsList.vue?vue&type=script&lang=js&"
export * from "./ContractsList.vue?vue&type=script&lang=js&"
import style0 from "./ContractsList.vue?vue&type=style&index=0&id=642f6e8d&lang=scss&scoped=true&"
import style1 from "./ContractsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f6e8d",
  null
  
)

export default component.exports